export default "__VITE_ASSET__BbTpB3rh__"